export default {
  'CHANGE_REFERENCES' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_REFERENCES' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/references/mutations.js